// extracted by mini-css-extract-plugin
export default {"payment-option":"PaymentOption_payment-option__5cLYR","active":"PaymentOption_active__EqIms"};